import React from 'react'
import classNames from 'classnames'

import iconEdit from 'images/icons/edit.svg'
import iconDelete from 'images/icons/rubbish-bin.svg'
import iconAdd from 'images/icons/add.svg'

import { DEFAULT_CURRENCY_SYMBOL } from 'constants/currencies'

import { getMonthlyFormattedPrice, getYearlyFormattedPrice } from 'utils/payments'

import warningIcon from './i/warning.svg'

import styles from './PriceBlock.module.scss'

const EditButton = ({ onClick }) => (
    <img onClick={onClick} src={iconEdit} alt="edit" className={styles.icon} title="Edit" />
)
const DeleteButton = ({ onClick }) => (
    <img onClick={onClick} src={iconDelete} alt="delete" className={styles.icon} title="Delete" />
)
const AddButton = ({ onClick }) => (
    <img onClick={onClick} src={iconAdd} alt="add" className={classNames(styles.icon, styles.isAddIcon)} title="Add" />
)

const PriceBlock = ({
    price,
    isWarning,
    isShowEditButton,
    isShowRemoveButton,
    isShowAddButton,
    onEdit,
    onDelete,
    onAdd,
    currencySymbol,
    billingCycle,
    isHighlightDefaultPriceRate,
    defaultPriceRate,
    defaultPriceDiffPercentage,
}) => (
    <div className={styles.priceBlock}>
        {isWarning && (
            <img
                title="Inflated price is less then real price (will not ne shown in pricing)"
                style={{ cursor: 'help' }}
                className={styles.warning}
                src={warningIcon}
                alt="warning"
            />
        )}
        {!!price ? (
            <div className={styles.priceBox}>
                <div className={styles.main}>
                    {getMonthlyFormattedPrice(price, currencySymbol, billingCycle)}
                    {isShowEditButton && <EditButton onClick={onEdit} />}
                    {isShowRemoveButton && <DeleteButton onClick={onDelete} />}
                </div>
                {defaultPriceRate && (
                    <div className={styles.exchangeRate}>
                        ≈ {getMonthlyFormattedPrice(defaultPriceRate, DEFAULT_CURRENCY_SYMBOL, billingCycle)}
                        &nbsp;({defaultPriceDiffPercentage}%){' '}
                        {isHighlightDefaultPriceRate && (
                            <img
                                style={{ cursor: 'help' }}
                                title="There may be a big difference in price"
                                src={warningIcon}
                                alt="warning"
                            />
                        )}
                    </div>
                )}
                {billingCycle === 12 && (
                    <div className={styles.per}>
                        <span className={styles.perPrice}>
                            {getYearlyFormattedPrice(price, currencySymbol, billingCycle)}
                        </span>{' '}
                        / year
                    </div>
                )}
            </div>
        ) : (
            <>{isShowAddButton && <AddButton onClick={onAdd} />}</>
        )}
    </div>
)

export default PriceBlock
